<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Tracking.isForm" flat class="pa-2 text-no-wrap">
        <h2 class="pa-2">
          {{ $t(`table.filter`) }}
        </h2>
        <v-layout align-center>
          <v-col cols :sm="3" class="pa-2">
            <v-datePickerRange v-model="dateRange" :rules="[Rules.required]" />
          </v-col>
          <v-col cols :sm="3" class="pa-2">
            <v-autocomplete
              :label="$t('table.type')"
              :items="dateList"
              v-model="type"
            />
          </v-col>
        </v-layout>
        <v-data-table
          v-if="isLoading"
          loading
          :loading-text="$t(`table.loadingText`)"
        />
        <v-data-table
          v-if="!isLoading"
          :items="Tracking.list"
          :headers="
            Object.keys(Tracking.list.length ? Tracking.list[0] : []).map(
              (e) => ({
                text: e,
                value: e,
                sortable: false,
              })
            )
          "
          item-key="id"
          dense
          fixed-header
          must-sort
        >
          <template v-slot:top>
            <v-layout pa-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.tracking") }}</h2>
                <v-btnc
                  :size="30"
                  icon="mdi-download"
                  @click="_fnExport()"
                  v-if="fnCheckMission(Session, [{ m: TRACKING, p: EXPORT }])"
                />
              </v-layout>
            </v-layout>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";

export default {
  data() {
    return {
      model: "Tracking",
      isLoading: false,
      dateRange: [
        this.$moment().startOf("month").unix(),
        this.$moment().endOf("month").unix(),
      ],
      type: "day",
      dateList: [
        {
          text: this.$t("table.day"),
          value: "day",
        },
        {
          text: this.$t("table.week"),
          value: "week",
        },
        {
          text: this.$t("table.month"),
          value: "month",
        },
      ],
    };
  },
  created() {
    this._fnCallListView();
  },
  watch: {
    type: function (o, n) {
      if (o != n) this._fnCallListView();
    },
    dateRange: function (o, n) {
      if (o[0] != n[0] || o[1] != n[1]) this._fnCallListView();
    },
  },
  methods: {
    async _fnCallListView() {
      if (this.isLoading) return;
      this.isLoading = true;
      this[this.model].filter.createdAt = this.dateRange.map(
        (e) => this.$moment.unix(e).utc(true).unix() * 1000
      );
      await this.fnGets({
        url: `/v1/admin/tracking/${this.type}`,
        model: this.model,
      });
      this.isLoading = false;
    },
    _fnExport() {
      const xlsxData = XLSX.utils.json_to_sheet(this[this.model].list);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, xlsxData, "tracking");
      XLSX.writeFile(
        wb,
        `Tracking-${this.$moment().format("YYYYMMDDHHmmss")}.xlsx`
      );
    },
  },
};
</script>
